/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantAccountTypeDto } from '../models/PagedResultDto_ParticipantAccountTypeDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantAccountType_CreateUpdateParticipantAccountTypeDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantAccountType_CreateUpdateParticipantAccountTypeDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantAccountTypeService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantAccountTypeParticipantAccountTypesList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-account-type/participant-account-types-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantAccountType(
        requestBody?: Wealthlane_CustomerService_Dtos_ParticipantAccountType_CreateUpdateParticipantAccountTypeDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-account-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_ParticipantAccountTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantAccountType(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_ParticipantAccountTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-account-type',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantAccountType(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_ParticipantAccountType_CreateUpdateParticipantAccountTypeDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant-account-type/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppParticipantAccountType(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/participant-account-type/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantAccountType1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantAccountType_ParticipantAccountTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-account-type/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
